import { Component } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { AlertService } from 'sce-core';

@Component({
  selector: 'lfwms-gen-inter-rec-popup',
  templateUrl: './gen-inter-rec-popup.component.html',
  styleUrls: ['./gen-inter-rec-popup.component.css']
})
export class GenInterRecPopupComponent {


  public lookupSearchService: SearchService;
  private _mbolKeyWarningNoMap = {};
  private _waveKey: string ;

  constructor(public modalService: ModalService,
    public coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) { }

  public initializeComponents(columnName: string , requestArray: any[]) {
    this.initializeLookupSearchContext(columnName);
    this._doShipAndGetResponseTableData(columnName, requestArray);
  }



  /* initialize the table and search context */
  public initializeLookupSearchContext(columnName: string) {

    const searchParams: SearchParams = new SearchParams();
    if (columnName === 'orderKey') {
      searchParams.tableId =  'GENINTERFACEORDERTD';
    } else if (columnName === 'receiptKey'){
      searchParams.tableId =  'geninterfaceasntd';
    }
    // searchParams.tableId = 'GENINTERFACEORDERTD';
    searchParams.isFullFetch = false;
    searchParams.columnCount = 15; ///???
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
     searchParams.paginateLocally = true;
    // searchParams.defaultPageSize = 100;

    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

  }

  private _doShipAndGetResponseTableData(columnName: string , requestArray: string[]) {

    this.lookupSearchService.clearSearchStatus();
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(columnName, requestArray));
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });

  }


  private _getNewSearchCriteria(columnName, requestArray: string[]) {


    const searchCriteria = new SearchCriteria();
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = null;
      return clause;
    };

    requestArray.forEach(key => {
        const searchCondition = new Condition();
        searchCondition.isMandatory = false;
        searchCondition.operator = 'OR';

        searchCondition.clauses = []; // Initialize clauses array
        searchCondition.clauses.push(_createSearchClause(columnName, key));
        searchCriteria.conditions.push(searchCondition);
      });
    return searchCriteria;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.ts